
































































import {
	computed,
	defineComponent,
	nextTick,
	PropType,
	Ref,
	ref,
	watch,
} from '@vue/composition-api';
import FormSection from '@front-app/components/form/FormSection.vue';
import FormLabel from '@front-app/components/form/FormLabel.vue';
import FormError from '@front-app/components/form/FormError.vue';
import FormInput from '@front-app/components/form/FormInput.vue';
import { FullUser } from '@front-app/services/UserApi/UserModel';
import MonthPicker from '@front-app/components/inputs/MonthPicker.vue';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import { CurrentUserStore } from '@front-app/store/singletons/User';
import { v } from '@front-app/components/form/validation/useValidation';
import { inRange, requiredIfBoth } from '@front-app/components/form/validation/validators';
import { useFocusFirstInvalidField } from '@front-app/hooks/useFocusFirstInvalidField';
import EditorWrapper from '../../layouts/form/EditorWrapper.vue';

export default defineComponent({
	components: {
		FormSection,
		FormLabel,
		FormError,
		FormInput,
		MonthPicker,
		EditorWrapper,
	},
	props: {
		user: {
			type: Object as PropType<FullUser>,
			required: true,
		},
	},
	setup(props) {
		const { update } = CurrentUserStore.actions;

		const initialBirthYear = computed(() => props.user.birthdayYear);
		const birthdayYear: Ref<string | null> = ref(null);
		watch(initialBirthYear, (curr: string) => {
			birthdayYear.value = curr || null;
		}, { immediate: true });

		const initialBirthMonth = computed(() => props.user.birthdayMonth);
		const birthdayMonth = ref('');
		watch(initialBirthMonth, (curr: string) => {
			birthdayMonth.value = curr || '';
		}, { immediate: true });

		const initialBirthDay = computed(() => props.user.birthdayDay);
		const birthdayDay = ref('');
		watch(initialBirthDay, (curr: string) => {
			birthdayDay.value = curr || '';
		}, { immediate: true });
		const computedBirthdayDay = computed(() => {
			if (!birthdayMonth.value || !birthdayDay.value) {
				return null;
			}
			return birthdayDay.value;
		});

		const maxYear = new Date().getFullYear();
		const minYear = maxYear - 150;
		const validation = v({
			birthdayYear: {
				value: computed(() => birthdayYear.value || null),
				rules: [inRange(minYear, maxYear)],
			},
			birthdayMonth: {
				value: birthdayMonth,
				rules: [],
			},
			birthdayDay: {
				value: computedBirthdayDay,
				rules: [requiredIfBoth(() => birthdayMonth.value), inRange(1, 31)],
			},
		});

		const {
			focusFirstInvalid,
		} = useFocusFirstInvalidField({ containerSelector: '.personal-information__update-form' });
		const {
			track,
			clear,
			isLoading,
			isError,
			isSuccess,
		} = useAsyncStatus();
		const saveUser = async () => {
			validation.validate();
			if (!validation.isValid.value) {
				await nextTick();
				focusFirstInvalid();
				return;
			}
			await track(update({
				birthdayYear: birthdayYear.value || '',
				birthdayMonth: birthdayMonth.value || '',
				birthdayDay: computedBirthdayDay.value || '',
			}));
			clear(4000);
		};

		return {
			birthdayYear,
			birthdayMonth,
			birthdayDay,
			// Saving
			isLoading,
			isError,
			isSuccess,
			saveUser,
			// Validation
			validation,
			minYear,
			maxYear,
		};
	},
});
